import { render, staticRenderFns } from "./TeachCenterLayout.vue?vue&type=template&id=2d57df3c&scoped=true"
import script from "./TeachCenterLayout.vue?vue&type=script&lang=js"
export * from "./TeachCenterLayout.vue?vue&type=script&lang=js"
import style0 from "./TeachCenterLayout.vue?vue&type=style&index=0&id=2d57df3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d57df3c",
  null
  
)

export default component.exports